import React from "react";

const StoreNavigation = (props) => {
  const handleCategoryClickCallback = (category) => {
    const url = new URL(location);
    history.pushState({}, "", url);
    window.location = `/cmra_store?category=${category.slug}`;
  };

  const emptyProducts = [
    { name: "" },
    { name: "" },
    { name: "" },
    { name: "" },
  ];
  return props.categories
    ? props.categories.map((category, index) => (
        <div
          onClick={() => {
            handleCategoryClickCallback(category);
          }}
          className={
            props.selectedCategory &&
            props.selectedCategory.name == category.name
              ? "category-button-select"
              : "category-button"
          }
          key={"taxon" + index}
        >
          <i className="bx bx-list-ul"></i>
          <span className="button-title">{category.name}</span>
        </div>
      ))
    : emptyProducts.map((category, index) => (
        <div className={"category-button"} key={"taxon" + index}>
          <i className="bx bx-list-ul"></i>
          <span className="button-title">{category.name}</span>
        </div>
      ));
};

export { StoreNavigation };
